import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}
// 商品批量上下架
export function shopPutaway (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuproduct/edit/batch/putaway/state',
		method: 'post',
		data: obj
	})
}

// 获取有效菜谱
export function getRecipeNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menurecipe/has/detail/list',
		method: 'post',
		data: obj
	})
}
// 下发发布菜谱
export function xiafaRecipe (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/change/machine/recipe',
		method: 'post',
		data: obj
	})
}
// 获取营养信息详情
export function getYingyang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menumaterial/nutrition/detail/${data.nutritionId}`,
		method: 'post',
		data: obj
	})
}
// 获取菜品树列表
export function getDishTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/type/dishes/list',
		method: 'post',
		data: obj
	})
}
// 获取菜谱指定日期菜品详情
export function getMenurecipeByday (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/date/detail',
		method: 'post',
		data: obj
	})
}
// 删除菜谱
export function delMenurecipe (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v2/menurecipe/remove/${data.recipeId}`,
		method: 'post',
		data: obj
	})
}
// 删除菜谱详情
export function delMenurecipeDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/remove/detail',
		method: 'post',
		data: obj
	})
}
// 菜谱新增发布接口
export function addMenurecipe (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/add',
		method: 'post',
		data: obj
	})
}
// 商品上下架
export function changeProductState (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuproduct/edit/putaway/state',
		method: 'post',
		data: obj
	})
}
// 添加商家原材料树信息
export function addYuancailiaoTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterialcategory/add',
		method: 'post',
		data: obj
	})
}
// 修改商家原材料树信息
export function updateYuancailiaoTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterialcategory/edit',
		method: 'post',
		data: obj
	})
}
// 删除商家原材料树信息
export function delYuancailiaoTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menumaterialcategory/remove/${data}`,
		method: 'post',
		data: obj
	})
}
// 获取菜品类别树信息
export function getcaipinTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestype/all/list',
		method: 'post',
		data: obj
	})
}
// 获取商家原材料树信息
export function getYuancailiaoTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterialcategory/tree/list',
		method: 'post',
		data: obj
	})
}
// 清空点赞数
export function clearDianzanPaihang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/empty/like',
		method: 'post',
		data: obj
	})
}
// 获取菜品点赞排行
export function getDianzanPaihang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/like/ranking',
		method: 'post',
		data: obj
	})
}
// 获取点赞调查菜品
export function getDianzanDish (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/like/survey/list',
		method: 'post',
		data: obj
	})
}
// 获取菜品详情
export function getDishDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v2/menudishes/detail/${data.dishesId}`,
		method: 'post',
		data: obj
	})
}
// 获取菜品 新版本v2
export function getDish (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/page',
		method: 'post',
		data: obj
	})
}
// 获取菜品 简洁版
export function getDishList2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/all/basics/dishes/list',
		method: 'post',
		data: obj
	})
}
// 配置点赞调查菜品
export function saveDianzanDish (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/add/like/survey',
		method: 'post',
		data: obj
	})
}
// 获取原材料类别
export function getCailiaoTypes (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menunutrition/all/type/list',
		method: 'post',
		data: obj
	})
}
// 导入原料信息
export function getRawMaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/batch/import/material',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 获取所有食材营养信息
export function getYingyangMess (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menunutrition/all/list',
		method: 'post',
		data: obj
	})
}
// 商家新增原材料信息
export function addCailiao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/add',
		method: 'post',
		data: obj
	})
}
// 分页获取商家原材料信息
export function getCailiaoList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/page',
		method: 'post',
		data: obj
	})
}
// 修改商家原材料信息
export function putCailiaoByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/edit',
		method: 'post',
		data: obj
	})
}
// 删除指定商家原材料信息
export function delCailiaoByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menumaterial/remove/${data.materialId}`,
		method: 'post',
		data: obj
	})
}
// 导入原材料基础库
export function getMaterialBaseLibrary (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/lead/in/material',
		method: 'post',
		data: obj
	})
}
// 食物成分原材料录入
export function addNutrimententer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menunutrition/addMenuNutrition',
		method: 'post',
		data: obj
	})
}
// 食物成分原材料修改
export function editNutrimententer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menunutrition/updateMenuNutrition',
		method: 'post',
		data: obj
	})
}
// 食物成分原材料删除
export function delNutrimententer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menunutrition/remove/${data.nutritionId}`,
		method: 'post',
		data: obj
	})
}
// 分页获取原材料信息
export function getNutrimententerlist (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menunutrition/getMenuNutritionPage',
		method: 'get',
		params: obj
	})
}
// 新增菜品灶类信息
export function addZaolei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishescook/add',
		method: 'post',
		data: obj
	})
}
// 分页获取菜品灶类信息
export function getZaoleiList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishescook/page',
		method: 'get',
		params: obj
	})
}
// 修改菜品灶类信息
export function editZaoleiByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishescook/edit',
		method: 'post',
		data: obj
	})
}
// 删除菜品灶类信息
export function delZaoleiByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishescook/remove/${data.cookId}`,
		method: 'post',
		data: obj
	})
}
// 新增菜品标签基础信息
export function addBiaoqian (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheslabel/add',
		method: 'post',
		data: obj
	})
}
// 分页获取菜品标签基础信息
export function getBiaoqianList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheslabel/page',
		method: 'get',
		params: obj
	})
}
// 修改菜品标签基础信息
export function editBiaoqianByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheslabel/edit',
		method: 'post',
		data: obj
	})
}
// 删除菜品标签基础信息
export function delBiaoqianByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudisheslabel/remove/${data.labelId}`,
		method: 'post',
		data: obj
	})
}
// 新增菜品口味信息
export function addKouwei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestaste/add',
		method: 'post',
		data: obj
	})
}
// 分页获取菜品口味信息
export function getKouweiList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestaste/page',
		method: 'get',
		params: obj
	})
}
// 修改菜品口味信息
export function editKouweiByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestaste/edit',
		method: 'post',
		data: obj
	})
}
// 删除菜品口味信息
export function delKouweiByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishestaste/remove/${data.id}`,
		method: 'post',
		data: obj
	})
}
// 新增菜品类型信息
export function addType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestype/add',
		method: 'post',
		data: obj
	})
}
// 分页获取菜品类型信息
export function getTypeList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestype/page',
		method: 'get',
		params: obj
	})
}
// 修改菜品类型信息
export function editTypeByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishestype/edit',
		method: 'post',
		data: obj
	})
}
// 删除菜品类型信息
export function delTypeByid (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishestype/remove/${data.id}`,
		method: 'post',
		data: obj
	})
}
// 批量新增菜品
export function plAddcaipin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/batch/import/dishes',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 分页获取菜品信息
export function getDishList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/page',
		method: 'get',
		params: obj
	})
}
// 新增菜品信息
export function addDish2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) obj.content = data
	return request({
		url: '/api/v2/menudishes/add',
		method: 'post',
		data: obj
	})
}
// 修改菜品信息
export function editDish2 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/edit',
		method: 'post',
		data: obj
	})
}
// 删除菜品信息
export function delDish (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishes/remove/${data.dishesId}`,
		method: 'post',
		data: obj
	})
}
// 分页获取套餐信息
export function getTaocan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menupackagemeal/page',
		method: 'get',
		params: obj
	})
}

// 分页获取菜品计划
export function getCaipuList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/page',
		method: 'post',
		data: obj
	})
}
// 修改菜品计划详细信息
export function editCaipuDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menurecipe/detail/edit',
		method: 'post',
		data: obj
	})
}
// 批量删除菜品原材料
export function delCaiyuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/remove/batch',
		method: 'post',
		data: obj
	})
}

// 批量删除菜品计
export function delCaipin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/remove/batch',
		method: 'post',
		data: obj
	})
}
// 批量删除菜品计划详情
export function delCaipuDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menurecipe/detail/batch/remove',
		method: 'post',
		data: obj
	})
}
// 新增商品信息
export function addProduct (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuproduct/add',
		method: 'post',
		data: obj
	})
}
// 分页获取商品信息
export function getProductList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuproduct/page',
		method: 'post',
		data: obj
	})
}
// 修改商品信息
export function editProduct (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuproduct/edit',
		method: 'post',
		data: obj
	})
}
// 删除商品信息
export function delProduct (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menuproduct/remove/${data.productId}`,
		method: 'post',
		data: obj
	})
}
// 分页查询需审核菜品
export function getauditMenudish (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/aifoodcleaning/meal/page',
		method: 'get',
		params: obj
	})
}
// 获取单个审核菜品详情
export function getauditOne (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/aifoodcleaning/meal/review',
		method: 'get',
		params: obj
	})
}
// 查询菜品
export function getAudit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/aifoodcleaning/dish/all',
		method: 'get',
		params: obj
	})
}
// 新增菜品
export function addAudit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/aifoodcleaning/dish/one',
		method: 'post',
		data: obj
	})
}
// 单菜品图片上传
export function addAuditPicture (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/aifoodcleaning/dish/pic',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 菜谱信息推送
export function pushCaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ids/menu',
		method: 'post',
		data: obj
	})
}
// 1分页查询菜品分类
export function getdishesfenlei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesclassify/page',
		method: 'get',
		params: obj
	})
}
// 1新增菜品分类
export function pushdishesfenlei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesclassify/add',
		method: 'post',
		data: obj
	})
}
// 1修改菜品分类
export function editdishesfenlei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesclassify/edit',
		method: 'post',
		data: obj
	})
}
// 1删除菜品分类
export function delDishesfenlei (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishesclassify/remove/${data.classifyId}`,
		method: 'post',
		data: obj
	})
}
// 1分页查询菜品功效
export function getdishesgongxiao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheseffect/page',
		method: 'get',
		params: obj
	})
}
// 1新增菜品功效
export function pushdishesgongxiao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheseffect/add',
		method: 'post',
		data: obj
	})
}
// 1修改菜品功效
export function editdishesgongxiao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudisheseffect/edit',
		method: 'post',
		data: obj
	})
}
// 1删除菜品功效
export function delDishesgongxiao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudisheseffect/remove/${data.effectId}`,
		method: 'post',
		data: obj
	})
}
// 1分页查询菜系
export function getdishescaixi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesstyle/page',
		method: 'get',
		params: obj
	})
}
// 1新增菜系
export function pushdishescaixi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesstyle/add',
		method: 'post',
		data: obj
	})
}
// 1修改菜系
export function editdishescaixi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishesstyle/edit',
		method: 'post',
		data: obj
	})
}
// 1删除菜系
export function delDishescaixi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishesstyle/remove/${data.styleId}`,
		method: 'post',
		data: obj
	})
}
// 1分页查询适应人群
export function getdishessyrq (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishessuit/page',
		method: 'get',
		params: obj
	})
}
// 1新增适应人群
export function pushdishessyrq (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishessuit/add',
		method: 'post',
		data: obj
	})
}
// 1修改适应人群
export function editdishessyrq (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishessuit/edit',
		method: 'post',
		data: obj
	})
}
// 1删除适应人群
export function delDishessyrq (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/menudishessuit/remove/${data.suitId}`,
		method: 'post',
		data: obj
	})
}

// 获取留样记录
export function getSamplerecord (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/macsavesample/page/save/sample/record',
		method: 'post',
		data: obj
	})
}
// 慢病咨询订阅新增
export function addConsultation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/healthconsultation/addConsultation',
		method: 'post',
		data: obj
	})
}

// 获取食堂未留样菜品
export function getSamplerecordcanteen (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/macsavesample/page/diff/sample/record',
		method: 'post',
		data: obj
	})
}
// 慢病咨询订阅查询
export function getConsultation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/healthconsultation/page',
		method: 'get',
		params: obj
	})
}

// 慢病咨询订阅查询--详情
export function getConsultationDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/healthconsultation/page/detail',
		method: 'get',
		params: obj
	})
}

// 慢病咨询订阅修改
export function updateConsultation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/healthconsultation/update',
		method: 'post',
		data: obj
	})
}

// 删除慢病营养科普详情
export function delConsultation (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/healthconsultation/remove/detail/${
			data.consultationId
		}`,
		method: 'delete',
		data: obj
	})
}

// 删除慢病咨询订阅
export function delChronicId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/healthconsultation/remove/${data.chronicId}`,
		method: 'delete',
		data: obj
	})
}

// 获取菜品拍照的食堂档口
export function getMenuaicanteen (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/list/menuai/canteen',
		method: 'post',
		data: obj
	})
}

// 分页获取食堂档口的菜品照片
export function getMenuaidishespicture (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/yunshitang/menuai/dishes/picture',
		method: 'post',
		data: obj
	})
}

// 批量修改照片接口
export function plEditdishespicture (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/update/dishes/picture',
		method: 'post',
		data: obj
	})
}

// 批量删除多张菜品照片接口
export function plDeldishespicture (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/remove/dishes/pciture',
		method: 'post',
		data: obj
	})
}

// 根据菜谱获取菜品拍照张数
export function getDishesnum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menuai/page/menuai/dishes/num',
		method: 'post',
		data: obj
	})
}

// 导入菜品基础库
export function importInitmenudishes (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menudishes/init/data',
		method: 'post',
		data: obj
	})
}
// 新版下发菜谱
export function xiafaRecipeNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/tcp/v1/menudishes/issue/recipesellect',
		method: 'post',
		data: obj
	})
}
// 菜谱发布到移动端或解绑
export function fabuCaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/app/bind',
		method: 'post',
		data: obj
	})
}
// 菜谱发布到移动端或解绑
export function fabuCaipuList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/app/bind/list',
		method: 'post',
		data: obj
	})
}
// 编辑菜谱
export function editCaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/edit/base',
		method: 'post',
		data: obj
	})
}
// 菜谱菜品 批量导入
export function exportCaipu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/recipe/import/dishes',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 根据日期区间查询菜谱中的菜品信息
export function getCaipuDetailByDate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menurecipe/recipe/get/between/date',
		method: 'post',
		data: obj
	})
}
// 复制菜品
export function menudishesCopy (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/copy',
		method: 'post',
		data: obj
	})
}
// 获取按食堂管理配置信息
export function getCanteenManageConfigApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/get/dif-canteen-manage',
		method: 'post',
		data: obj
	})
}
export function editCanteenManageConfigApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/menudishes/edit/dif-canteen-manage',
		method: 'post',
		data: obj
	})
}
export function updateCategoryApi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/material/batch/update/category',
		method: 'post',
		data: obj
	})
}
// 菜品批量导入校验
export const dishesBatchImportCheck = (data) => {
	return request({
		url: '/api/v2/menudishes/import/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data,
		mock: false
	})
}
// 菜品批量导入确认
export const dishesBatchImport = (data) => {
	return request({
		url: '/api/v2/menudishes/import/dishes',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 菜品批量导入轮询查询结果
export const dishesBatchImportResult = () => {
	return request({
		url: '/api/v2/menudishes/import/result',
		params: dataObj,
		mock: false
	})
}
// 原料批量导入校验
export const materialBatchImportCheck = (data) => {
	return request({
		url: '/api/v1/menumaterial/import/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data,
		mock: false
	})
}
// 原料批量导入确认
export const materialBatchImport = (data) => {
	return request({
		url: '/api/v1/menumaterial/import/dishes',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 原料批量导入轮询查询结果
export const materialBatchImportResult = () => {
	return request({
		url: '/api/v1/menumaterial/import/result',
		params: dataObj,
		mock: false
	})
}
